module.exports = __webpack_public_path__ + "static/media/cover5.e2886eb1.jpeg";